module.exports = "/assets/images/checkmark-in-circle_3e7c08.svg";